import { useEffect, useState } from 'react';

import { AImage, AButton } from 'components/atoms';
import { InfoVacant } from 'components/molecules';
import OnboardingModal from 'components/molecules/OnboardingModal/OnboardingModal.component';
import { ProfileCircleCard } from 'components/molecules/ProfileCircleCard/ProfileCircleCard.components';
import { SideMenu } from 'components/molecules/SideMenu/SideMenu.components';
import useGetName from 'hooks/useGetName';
import { useWindowMobile } from 'hooks/useWindowMobile';
import { useGetAdmissionDateQuery } from 'services/talento';
import { selectOnboardingDashboard, selectUi } from 'store';
import { useAppSelector } from 'store/hooks';
import './Header.scss';
import pragmaCircleLogo from 'utils/assets/images/pragmaCircleLogo.svg';
import { TabbarItemPath } from 'utils/constants';
import { ONBOARDING_MODALS } from 'utils/constants/Onboarding/indexOnboarding';
import { userStates } from 'utils/helpers';
import { Numbers } from 'utils/helpers/dictionaries';
import { uiModes } from 'utils/interfaces/store/ui.interfaces';

import { selectStages, selectUserInfo } from '../../../store/user/user.slice';
import { NotificationsPanel } from '../NotificationsPanel/NotificationsPanel.components';
interface IProps {
  hiddenItems?: TabbarItemPath[];
  isMenuOpen?: boolean;
  isContractingActivities?: boolean;
}

export const OHeader = ({ hiddenItems, isMenuOpen, isContractingActivities }: IProps) => {
  const { isMobile } = useWindowMobile(1279);
  const { t, fullName, vacantName, isLoadingVacant, firstLetterName, lastNameInitial, preferredName } =
    useGetName();
  const { isLogged, userState, email } = useAppSelector(selectUserInfo);
  const { isLoadingStages } = useAppSelector(selectStages);
  const { mode } = useAppSelector(selectUi);

  const [openInfoVacant, setOpenInfoVacant] = useState<boolean>(false);
  const [isLightMode, setIsLightMode] = useState<boolean>(false);

  const firstName: string | null = preferredName || fullName?.split(' ')[0];
  const { data: admissionDateData, refetch: refetchAdmissionData } = useGetAdmissionDateQuery({
    email,
  });
  const { showOnboarding, step } = useAppSelector(selectOnboardingDashboard);

  useEffect(() => {
    if (userState === userStates.hire && !admissionDateData) {
      refetchAdmissionData();
    }
  }, [userState]);

  useEffect(() => {
    if (isLogged && !isLoadingStages && !isLoadingVacant && vacantName) {
      setTimeout(() => {
        document.getElementById('header_logo')?.classList.add('header_logo--show');
      }, 400);

      setTimeout(() => {
        document
          .getElementById('header__logo-background')
          ?.classList.add('header__logo-background--show');
      }, 1250);

      setTimeout(() => {
        document.getElementById('header__container')?.classList.add('header__container--show');
      }, 1250);

      setTimeout(() => {
        document
          .getElementById('header__container--info')
          ?.classList.add('header__container--info--show');
      }, 1250);

      setTimeout(() => {
        document
          .getElementById('header__container--border')
          ?.classList.add('header__container--border--show');
      }, 1250);

      setTimeout(() => {
        document
          .getElementById('header__container--right')
          ?.classList.add('header__container--show');
      }, 1250);
    }
  }, [isLogged, isLoadingStages, isLoadingVacant, vacantName]);

  useEffect(() => {
    if (isLightMode) {
      document
        .getElementById('header__container--border')
        ?.classList.add('header__container--border-light-mode');
      document
        .getElementById('header__logo-background')
        ?.classList.add('header__logo-background--light-mode');
    } else {
      document
        .getElementById('header__container--border')
        ?.classList.remove('header__container--border-light-mode');
      document
        .getElementById('header__logo-background')
        ?.classList.remove('header__logo-background--light-mode');
    }
  }, [isLightMode]);

  useEffect(() => {
    setIsLightMode(mode === uiModes.LIGHT);
  }, [mode]);

  return (
    <>
      <InfoVacant
        isOpen={openInfoVacant}
        close={setOpenInfoVacant}
        vacantName={vacantName}
        isMenuOpen={isMenuOpen}
      />
      <div className='header'>
        <section
          className='header__container header__container--left'
          id='header__container'
        ></section>
        <div className='header_logo' id='header_logo'>
          <div className='header__logo-background' id='header__logo-background'></div>

          {isContractingActivities && (
            <>
              <AImage
                className={`header_logo__image ${
                  isLightMode ? 'header_logo__image--light-mode' : ''
                }`}
                url={pragmaCircleLogo}
                alt=''
                dataTestid='desktop-logo'
              />
              <p
                className={`header_logo__text ${
                  isLightMode ? 'header_logo__text--light-mode' : ''
                }`}
              >
                Ingreso
                <span className='header_logo__text--modifier'>Pragma</span>
              </p>
            </>
          )}

          {isMobile && !isContractingActivities && <SideMenu hiddenItems={hiddenItems} />}
        </div>

        <section className='header__container--info' id='header__container--info'>
          <header className='home__header'>
            <div className='home__header__info'>
              <h2 className='home__header__info__greetings'>
                {t('greetings', { $1: firstName ?? fullName }).replace(/^¡Hola\s+/, '¡Hola, ')}
              </h2>
              <p className='home__header__info__position'>
                {admissionDateData?.data.admissionDate && admissionDateData?.data.admissionHour ? (
                  <span className={`home__header__info__position__link`}>
                    Nos veremos el {admissionDateData.data.admissionDate} a las{' '}
                    {admissionDateData.data.admissionHour}
                  </span>
                ) : (
                  <>
                    {`${t('youAreOnYourWay')} `}
                    <AButton
                      tag='a'
                      className='home__header__info__position__link underline'
                      handleClick={() => {
                        setOpenInfoVacant(true);
                      }}
                    >
                      {isLoadingVacant ? 'loading...' : vacantName}
                    </AButton>
                  </>
                )}

                {showOnboarding && step === 1 && (
                  <OnboardingModal
                    title={ONBOARDING_MODALS[1].TITLE}
                    text={ONBOARDING_MODALS[1].TEXT}
                    step={Numbers.one}
                    className={`modalOnboardingOne ${
                      vacantName.length > 18 ? 'modalOnboardingOne--left' : ''
                    }`}
                    trianglePosition={ONBOARDING_MODALS[1].TRIANGLE_POSITION}
                  />
                )}
              </p>
            </div>
            <div className='profile__section'>
              <NotificationsPanel />
              <ProfileCircleCard name={firstLetterName} secondName={lastNameInitial} header />
            </div>
          </header>
        </section>
        <section
          className='header__container header__container--right'
          id='header__container--right'
        ></section>
        <div className={`header__container--border`} id='header__container--border'></div>
      </div>
    </>
  );
};
